module.exports = __webpack_public_path__ + "static/img/lifestyle_11.c0652828.jpg";